import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="layout">
      {/* Header */}
      <header className="layout-header">
        <div className="header-content">
          <div className="header-left">
            <div className="logo">
              <span className="logo-icon">📻</span>
              <h1>Radio Itajaí</h1>
            </div>
          </div>
          <div className="header-right">
            <div className="user-info">
              <span className="user-name">👤 {user?.username}</span>
            </div>
            <button onClick={handleLogout} className="logout-button">
              <span className="logout-icon">🚪</span>
              Sair
            </button>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav className="layout-nav">
        <div className="nav-content">
          <ul className="nav-links">
            <li className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}>
              <Link to="/dashboard" className="nav-link">
                <span className="nav-icon">📊</span>
                Dashboard
              </Link>
            </li>
            <li className={`nav-item ${isActive('/analyses') ? 'active' : ''}`}>
              <Link to="/analyses" className="nav-link">
                <span className="nav-icon">📋</span>
                Análises
              </Link>
            </li>
          </ul>
        </div>
      </nav>

      {/* Main Content */}
      <main className="layout-main">
        <div className="main-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout; 